import { useState } from 'react';

export const useModalToggle = (defaultValue = false): [boolean, () => void] => {
  const [modalToggle, setModalToggle] = useState(defaultValue);
  const modalToggleHandler = () => setModalToggle((value) => !value);

  return [modalToggle, modalToggleHandler];
};
